import { useEffect } from "react";
import { useSetState } from "./useSetState";

export type usePersistStateProps<S> = [
	state: S,
	setState: React.Dispatch<S>,
	getState: () => Promise<S>,
];

export function usePersistState<S>(
	key: string,
	initialValue: S,
): usePersistStateProps<S> {
	const [state, setState, getState] = useSetState<S>(() => {
		const storageValue = sessionStorage.getItem(key);

		return storageValue ? JSON.parse(storageValue) : initialValue;
	});

	useEffect(() => {
		sessionStorage.setItem(key, JSON.stringify(state));
	}, [state, key]);

	return [state, setState, getState];
}
